import React, { useState } from "react";
import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import eidWish from "../../images/eidWish.jpg";
import pkFlag from "../../images/pkFlag.webp";
import "./eidModal.css";
export const NoticeModal = () => {
  const location = useLocation();

  const [show, setShow] = useState(false);
  const onClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const accept = () => {
    localStorage.setItem("disclaimer", true);
    onClose();
  };

  useEffect(() => {
    // let check = localStorage.getItem("disclaimer");
    if (
      location.pathname.includes("/admin") ||
      location.pathname.includes("admin-login") ||
      location.pathname.includes("super-admin-login") ||
      location.pathname.includes("waqar-login")
    ) {
    } else {
      handleShow();
    }

    // if (check == "true") {
    // } else {
    //   handleShowMore();
    // }
  }, []);

  return (
    <Modal
      show={show}
      centered
      onHide={onClose}
      contentClassName="eid-modal-content"
      dialogClassName="eid-modal-dialog"
    >
      <Modal.Body className="p-0">
        <div className="eid-modal">
          {/* LEFT RAIL */}
          <aside className="eid-rail" aria-hidden="true">
            <span className="eid-rail-corner tl" />
            <span className="eid-rail-corner bl" />

            <div className="eid-rail-stamp">Holiday Notice</div>

            <div className="eid-moon-wrap">
              <span className="eid-moon-ring r2" />
              <span className="eid-moon-ring" />
              <span className="eid-moon-disc" />
              <span className="eid-spark a" />
              <span className="eid-spark b" />
              <span className="eid-spark c" />
              <span className="eid-spark d" />
            </div>

            <div className="eid-rail-greet">
              <span className="ar">Eid</span>
              <span className="lo">Mubarak</span>
              <span className="dash" />
              <span className="date">1447 AH</span>
            </div>
          </aside>

          {/* RIGHT CONTENT */}
          <div className="eid-content">
            {/* Close button */}
            <button className="eid-close" aria-label="Close" onClick={onClose}>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>

            {/* Meta bar */}
            <div className="eid-meta">
              <span className="num">01</span>
              <span>From the team</span>
              <span className="line" />
              <span className="right">// holiday-notice</span>
            </div>

            <h2 className="eid-salute">Dear Valued Clients,</h2>
            <p className="eid-sub-headline">A note from Team Waqar Zaka</p>

            <div className="eid-divider" />

            <div className="eid-body">
              <p>
                Please be informed that our office will remain{" "}
                <b>closed due to Eid holidays</b>. Regular operations will
                resume after the holidays.
              </p>
              <p>
                Response times may be slightly delayed during this period. We
                sincerely appreciate your patience and understanding.
              </p>
              <p>
                We wish you and your family a joyful and blessed Eid filled with
                happiness and prosperity.
              </p>
            </div>

            {/* Prayer block */}
            <div className="eid-prayer">
              <span className="eid-prayer-ico" aria-hidden="true" />
              <span>
                Please remember <b>Waqar Zaka and the team</b> in your prayers.
              </span>
            </div>

            {/* Eid Mubarak line */}
            <p className="eid-mubarak">
              Eid Mubarak
              <span className="star">✦</span>
              <span className="underline" />
            </p>

            {/* Footer */}
            <div className="eid-footer">
              <div className="eid-sign">
                <span className="r">Best regards,</span>
                <b>Team Waqar Zaka</b>
              </div>
              <div className="eid-actions">
                <button className="eid-btn-secondary" onClick={onClose}>
                  Close
                </button>
                <button className="eid-btn-primary" onClick={onClose}>
                  Got it
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12h14" />
                    <path d="m13 6 6 6-6 6" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
    // <Modal show={showMore} centered>
    //   <Modal.Body>
    //     <div className="otpModalMain broadcastModal">
    //       <div className="closeIcon" onClick={handleCloseMore}>
    //         <i className="fa-solid fa-xmark" />
    //       </div>

    //       <div className="showMoreModalM">
    //         <div className="showMoreModal">
    //           {/* <div className="eidModalImg">
    //             <img src={eidWish} alt="eid mubarak" />
    //           </div> */}
    //           <h4 className="mt-3 text-center">Dear Valued Clients,</h4>
    //           {/* <h4 className="mb-3 text-center">📢 Notice for Indian Users</h4> */}
    //           {/* <p className="desc1 mb-3 text-center">Dear Valued Clients,</p> */}
    //           <p className="desc1 mb-3 text-center">
    //             Please be informed that our office will remain closed due to Eid
    //             holidays. Regular operations will resume after the holidays.
    //           </p>
    //           <p className="desc1 mb-3 text-center">
    //             Response times may be slightly delayed during this period. We
    //             sincerely appreciate your patience and understanding.
    //           </p>
    //           <p className="desc1 mb-3 text-center">
    //             We wish you and your family a joyful and blessed Eid filled with
    //             happiness and prosperity.
    //           </p>
    //           <p className="desc1 mb-3 text-center">
    //             Please remember Waqar Zaka and the team in your prayers.
    //           </p>
    //           <p className="desc1 mb-3 text-center">Eid Mubarak ✨ </p>
    //           {/* <div className="text-center mb-3">
    //             <a
    //               href="https://www.weex.com/events/promo/otc-20-4?vipCode=z5je&qrType=activity"
    //               target="_blank"
    //               className="themeBtn"
    //               style={{ color: "#fff" }}
    //             >
    //               Join
    //             </a>
    //           </div> */}

    //           {/* <h4 className="mb-3 text-center">
    //             Important Update for Group Members
    //           </h4> */}

    //           {/* <p className="desc1 mb-2">
    //             <b> January 14–16:</b> Only one live session will take place at
    //             11:00 PM (Pakistan Time).
    //           </p>
    //           <p className="desc1 mb-2">
    //             From <b> January 19</b> onward, both live sessions will resume
    //             at their regular timings.
    //           </p>
    //           <p className="desc1 mb-1">Regular LIVE Session Schedule:</p>
    //           <p className="desc1 mb-1">2 live sessions daily</p>
    //           <p className="desc1 mb-2">
    //             <ul>
    //               <li>9:00 PM (Pakistan Time)</li>
    //               <li>11:00 PM (Pakistan Time)</li>
    //             </ul>
    //           </p> */}

    //           {/* <p className="desc1 mb-3">
    //             <b>📢 Session Time Update</b>
    //           </p>
    //           <p className="desc1 mb-3">Our live session time has changed!</p>
    //           <p className="desc1 ">
    //             🕕 New Timing: 9:00 PM PKT & 11:00 PM PKT{" "}
    //           </p>
    //           <p className="desc1 mb-3">📅 Days: Monday to Friday</p>
    //           <p className="desc1 mt-3 ">
    //             Please note: Saturday and Sunday – No session.
    //           </p> */}

    //           {/* <p className="desc1 mt-3  mb-0">
    //             Thank you for staying with us!{" "}
    //           </p> */}
    //           <p className="desc1 text-center">
    //             <b> Best regards,</b>
    //           </p>
    //           <p className="desc1  text-center">
    //             <b>Team Waqar Zaka.</b>
    //           </p>
    //         </div>
    //       </div>
    //     </div>
    //   </Modal.Body>
    // </Modal>
  );
};
